import styled from "styled-components";
import {Brand} from "nav/normal/NavBar.styles";
import {surfaceHeight} from "nav/SiteFooter.styles";

/**
 * The app's CssBaseline may never have mounted, so this surface owns its entire background.
 *
 * It fills the SURFACE rather than the window (ui#2635). This view replaces the whole shell — it is a
 * route error element and lives outside `RootLayout` — so no legal footer row is mounted beside it and
 * the reserve resolves to zero, which makes this exactly one dynamic viewport. Taking the shared
 * declaration rather than writing `100vh` here is what puts this surface under the same unit rule as
 * every other full-height box (ui#687): `100vh` is the LARGE viewport, so the recovery page was taller
 * than a phone with its address bar showing could display.
 */
export const ErrorBackdrop = styled.div`
	${surfaceHeight("min-height")}
	background: ${({theme}) => theme.tokens.paper};
`;

/** The existing brand presentation, without introducing a navigation control during recovery. */
export const ErrorBrand = styled(Brand).attrs({as: "div"})`
	cursor: default;
	margin-bottom: 20px;
`;
